






















































import {Vue, Component, Prop} from 'vue-property-decorator';
import {formatUnit} from '@/utils/unitUtils';
import {MeasurementData, NodeInputMeasurement} from '@/views/system/measurements/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';
//import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleDataRoutesByTypeMap} from '@/views/system/modules/configurate';
import {MeasurementType} from '@/views/system/measurements/enums';
import {addSignalSubscription} from '@/utils/socketUtils';
import {nodeStatusColorScheme} from '@/components/system/configurate';
import {PModuleType} from '@/enums/configs';
import {NodeData} from '@/system/nodes/interfaces';

@Component({})
export default class NodeInput extends Vue {
  connectionWorkStatus: WebSocket | null = null;
  value = '';
  vel_value: {[key: string]: NodeInputMeasurement} = {}; // {'vel_x': {value: NaN, axis: 'vel_x'}};
  vel_axis = 'vel_x';
  status = 0;
  colors = [
    /* 0 */ nodeStatusColorScheme.notAvailable,
    /* 1 */ nodeStatusColorScheme.bottomErrorBoundary,
    /* 2 */ nodeStatusColorScheme.bottomDangerBoundary,
    /* 3 */ nodeStatusColorScheme.bottomWarningBoundary,
    /* 4 */ nodeStatusColorScheme.normal,
    /* 5 */ nodeStatusColorScheme.topWarningBoundary,
    /* 6 */ nodeStatusColorScheme.topDangerBoundary,
    /* 7 */ nodeStatusColorScheme.topErrorBoundary,
  ];
  colorsWork = {active: 'green', inactive: 'blue', failed: 'red', other: 'black'};
  selectData = [];

  @Prop({required: true})
  module!: PModuleWithMeasurements;

  @Prop({required: true, type: String})
  id!: string;

  measurements: MeasurementData[] = [];

  @Prop({type: String})
  tooltipStr!: string;

  @Prop({type: Boolean, default: false})
  editFlag!: boolean;

  @Prop({type: Boolean, default: false})
  showTooltip!: boolean;

  @Prop({required: false})
  workStatuses?: any;

  @Prop({required: false})
  objlist!: NodeData[];

  // TODO логику с item, selectItem нужно переписать
  item = '';

  get selectItem() {
    if (this.measurements.length && !this.item) {
      if (this.module.type == PModuleType.DtcpAccelerometerModule) return 'vel_*';
      return this.measurements[0].alias;
    }
    return this.item;
  }

  set selectItem(val: string) {
    this.item = val;
  }

  get workStatus() {
    if (this.workStatuses) return this.workStatuses[this.id];
    return null;
  }

  get listNodes(): {id: string; name: string}[] {
    let menu: {id: string; name: string}[] = [];
    if (this?.module?.nodes)
      for (const n of this.module.nodes) {
        const node = this.objlist.find((o: NodeData) => o.id == n.node_id);
        if (node) menu.push({id: `${node?.id}`, name: `${node?.name}`});
        this.objlist.forEach((o: NodeData | undefined) => {
          const addon: {id: string; name: string}[] =
            o?.children
              ?.filter((child: NodeData) => child.id == n.node_id)
              .map((child: NodeData) => {
                return {id: `${child?.id}`, name: `${child?.name}`};
              }) || [];
          if (addon.length > 0) menu = menu.concat(addon);

          o?.children?.forEach((child: NodeData | undefined) => {
            const addon1: {id: string; name: string}[] =
              child?.children
                ?.filter((cc: NodeData) => cc.id == n.node_id)
                .map((ccc: NodeData) => {
                  return {id: `${ccc?.id}`, name: `${ccc?.name}`};
                }) || [];
            if (addon1.length > 0) menu = menu.concat(addon1);
          });
        });
      }
    return menu;
  }

  get listMenu(): {id: string; name: string}[] {
    const menu = this.measurements.map((item: MeasurementData): {id: string; name: string} => {
      return {id: item.alias, name: item.name};
    });
    if (this.module.type == PModuleType.DtcpAccelerometerModule) {
      return [{id: 'vel_*', name: 'Максимум виброскорости'}, ...menu];
    }
    return menu;
  }

  get phys(): string | undefined {
    const alias = this.selectItem == 'vel_*' ? this.vel_axis : this.selectItem;
    const addon = this.selectItem == 'vel_*' ? 'ᵐᵅˣ' : '';
    const selectItem = this.measurements.find((item: MeasurementData) => item.alias === alias);
    if (selectItem) return (selectItem?.phys != '-' ? selectItem?.phys : '') + addon;
    else return addon;
  }

  get eventType(): string | undefined {
    const alias = this.selectItem == 'vel_*' ? this.vel_axis : this.selectItem;
    const selectItem = this.measurements.find((item: MeasurementData) => item.alias === alias);
    return selectItem?.eventType;
  }

  get shortName(): string | undefined {
    const alias = this.selectItem == 'vel_*' ? this.vel_axis : this.selectItem;
    const selectItem = this.measurements.find((item: MeasurementData) => item.alias === alias);
    return selectItem?.shortName;
  }

  get unit(): string | undefined {
    const alias = this.selectItem == 'vel_*' ? this.vel_axis : this.selectItem;
    const selectItem = this.measurements.find((item: MeasurementData) => item.alias === alias);
    const unit = selectItem?.unit ? formatUnit(selectItem.unit) : '';
    return unit != '-' ? unit : '';
  }

  subscribeConectionValue(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (strParse) {
      const {
        module_identifier,
        module_alias,
      }: {
        module_identifier: string;
        module_alias: string;
      } = strParse;
      let m: NodeInputMeasurement = {
        value: strParse.value,
        axis: strParse.module_alias,
        bdb: strParse.beb,
        beb: strParse.bdb,
        bwb: strParse.bwb,
        tdb: strParse.teb,
        teb: strParse.tdb,
        twb: strParse.twb,
      };
      if (module_identifier !== this.module.guid) return;
      if (module_alias !== this.selectItem) {
        if (this.selectItem == 'vel_*' && module_alias.match(/vel_[xyz]$/)) {
          this.vel_value[module_alias] = m;
          m = Object.values(this.vel_value).reduce(
            (max: NodeInputMeasurement, item: NodeInputMeasurement) =>
              max.value > item.value ? max : item,
            this.vel_value[module_alias],
          );
          this.vel_axis = m.axis;
        } else return;
      }
      this.value = `${+m.value.toFixed(2)}`;
      this.status = 4; // normal
      if (typeof m.beb !== 'undefined' && m.beb !== null && m.value <= m.beb) this.status = 1;
      else if (typeof m.bdb !== 'undefined' && m.bdb !== null && m.value <= m.bdb) this.status = 2;
      else if (typeof m.bwb !== 'undefined' && m.bwb !== null && m.value <= m.bwb) this.status = 3;
      else if (typeof m.teb !== 'undefined' && m.teb !== null && m.value > m.teb) this.status = 7;
      else if (typeof m.tdb !== 'undefined' && m.tdb !== null && m.value > m.tdb) this.status = 6;
      else if (typeof m.twb !== 'undefined' && m.twb !== null && m.value > m.twb) this.status = 5;
    } else {
      this.status = 0;
      this.measurements = [];
      this.value = 'Нет данных';
    }
  }

  async created() {
    try {
      if (!this.module.id) return;

      //      const measurementSelection = this.module?.id
      //        ? await userSettingsStoreModule.getSelectedMeasurement(this.module.id)
      //        : null;

      //      if (measurementSelection) {
      //        this.selectItem = measurementSelection.selectedMeasurement;
      //      }

      await measurementsModule.fetchAll(); //TODO: вызывать 1 раз

      this.measurements = measurementsModule.all.filter(x =>
        this.module.measurements?.some(
          y => y.measurementId === x.id && x.type == MeasurementType.Signal,
        ),
      );

      this.subscribeToValues();
    } catch (e) {
      this.measurements = [];
    }
  }

  beforeDestroy() {
    // Если сокет уже открыт, то можем его закрыть, иначе дожидаемся открытия
    if (this.$dataSocketManager && this.module) {
      const aliases = this.selectItem == 'vel_*' ? ['vel_x', 'vel_y', 'vel_z'] : [this.selectItem];
      aliases.forEach(a => {
        const id = `${this.id}+${this.module.guid}+${a}`;
        this.$dataSocketManager.removeSubscription(id);
      });
    }
  }

  onClickNodeItem(evt: MouseEvent, item: string) {
    const {href} = this.$router.resolve({
      name: 'node',
      params: {id: item},
    });
    window.open(href, '_blank');
  }

  onClickMenuItem(alias: string) {
    const selectedMeasurement = this.measurements.find(
      (item: MeasurementData) => item.alias === alias,
    );
    if (this.$dataSocketManager && this.module) {
      const aliases = this.selectItem == 'vel_*' ? ['vel_x', 'vel_y', 'vel_z'] : [this.selectItem];
      aliases.forEach(a => {
        const id = `${this.id}+${this.module.guid}+${a}`;
        this.$dataSocketManager.removeSubscription(id);
      });
    }

    if (selectedMeasurement) {
      this.selectItem = selectedMeasurement.alias;
      //      userSettingsStoreModule.saveSelectedMeasurementMutation({
      //        pModuleId: this.module.id,
      //        selectedMeasurement: this.selectItem,
      //      });
      this.subscribeToValues();
    } else if (this.module.type == PModuleType.DtcpAccelerometerModule && alias == 'vel_*') {
      this.selectItem = alias;
      //      userSettingsStoreModule.saveSelectedMeasurementMutation({
      //        pModuleId: this.module.id,
      //        selectedMeasurement: this.selectItem,
      //      });
      this.subscribeToValues();
    }
  }

  subscribeToValues() {
    if (this.module && this.$dataSocketManager) {
      const aliases = this.selectItem == 'vel_*' ? ['vel_x', 'vel_y', 'vel_z'] : [this.selectItem];
      aliases.forEach(a => {
        const id = `${this.id}+${this.module.guid}+${a}`;
        const params = {
          moduleType: this.module.type,
          moduleGUID: this.module.guid as string,
          alias: a,
          eventType: this.eventType ?? 'value_changed',
        };
        const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
        const subscriptionFunction = (socket: WebSocket) =>
          addSignalSubscription.call(this, socket, params);
        this.$dataSocketManager.addSubscription(
          id,
          subscrName,
          subscriptionFunction,
          this.subscribeConectionValue,
        );
      });
    }
  }

  onClickInput(evt: MouseEvent) {
    if (this.editFlag) return;
    // Если сокет  уже открыт, то посылаем сообщение, иначе ждем пока откроется и затем шлем сообщение. Если был закрыт сервером из-за просроченного токена, то просто переходим на страницу, где происходит логаут
    // if (this.connectionValue)
    //   if (this.connectionValue.readyState === WebSocket.OPEN) this.connectionSendClick();
    //   else if (this.connectionValue.readyState === WebSocket.CLOSED) {
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(this.module.type),
      params: {id: `${this.module.id}`},
    });
    window.open(href, '_blank');
    // } else this.connectionValue.onopen = this.waitForSend;
    evt.stopPropagation();
  }

  // waitForSend() {
  //   this.connectionSendClick();
  // }

  connectionSendClick() {
    // if (this.connectionValue) {
    //   this.connectionValue.send('click');
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(this.module.type),
      params: {id: `${this.module.id}`},
    });
    window.open(href, '_blank');
    // }
  }
}
